import _ from 'lodash'
import md5 from 'js-md5'
import {API} from '@/util/api'
import {requestByPost} from '../../util/request'
/**
 * 用户模块
 */
export default {
    // namespaced: true 的方式使其成为带命名空间的模块。保证在变量名一样的时候，添加一个父级名拼接
    namespaced: true,
    state: {
        // 这里放全局参数
        token: '' // token
    },
    getters: {
        // 这里放get方法 this.$store.getters['user/getUserId']
        getToken() { // 生成token
            let rod = Math.floor(Math.random() * 999999)
            let token = md5(rod + 'xtzz')
            return token
        }
    },
    mutations: {
        // 这里是set方法  this.$store.commit('setDemoValue', value);
    },
    actions: {
        fnLoginNoCheckDoLogin({ commit }, data) { // 登录
            return requestByPost(API.loginNoCheckDoLogin, data)
        },
        fnRegisterNoCheckDoRegister({ commit }, data) { // 注册
            return requestByPost(API.registerNoCheckDoRegister, data)
        },
        fnWxLoginQuery({ commit }, data) { // 注册
          return requestByPost(API.wxLoginCheck, data)
        },
        fnCheckPhoneHave({ commit }, data) { // 校验手机号码
          return requestByPost(API.noCheckCheckPhoneHave, data)
        },
        checkLoginPhoneHave({ commit }, data) { // 校验手机号码
          return requestByPost(API.checkLoginPhoneHave, data)
        },
        fnLoginDoLogout({ commit }, data) { // 退出登录
          return requestByPost(API.loginDoLogout, data)
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js